"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadClientPlugins = exports.installPluginRuntime = exports.wirePluginHostState = void 0;
const React = __importStar(require("react"));
const api_1 = require("@cc-plugins/api");
// Side-effect: gamemode's declaration-merge for runtime.config/host types.
require("@creature-chess/gamemode/client");
const ReduxToolkit = __importStar(require("@reduxjs/toolkit"));
const ReactJss = __importStar(require("react-jss"));
const ReactRedux = __importStar(require("react-redux"));
const sessionSources_1 = require("~/networking/sessionSources");
const readyQueue_1 = require("./readyQueue");
const registry_1 = require("./registry");
let storeRef = null;
let localPlayerIdGetter = null;
const readyQueue = (0, readyQueue_1.createReadyQueue)();
const requireWired = () => {
    if (!storeRef || !localPlayerIdGetter) {
        throw new Error("Plugin called runtime.host.* before the host wired its state. " +
            "Defer state reads to `runtime.onReady(() => ...)` or to a listener registered via the plugin's `listeners` array.");
    }
    return { store: storeRef, getLocalPlayerId: localPlayerIdGetter };
};
const hostSelectors = {
    getLocalPlayerId: () => requireWired().getLocalPlayerId(),
    getCurrentPhase: () => requireWired().store.getState().game.roundInfo.phase,
    getSession: () => (0, sessionSources_1.getCurrentSession)(),
    subscribeSession: (listener) => (0, sessionSources_1.subscribeSession)(listener),
};
const wirePluginHostState = (params) => {
    storeRef = params.store;
    localPlayerIdGetter = params.getLocalPlayerId;
    readyQueue.fire();
};
exports.wirePluginHostState = wirePluginHostState;
/** Must run before any plugin bundle loads. */
const installPluginRuntime = () => {
    const existing = globalThis[api_1.CLIENT_PLUGIN_RUNTIME_KEY];
    if (existing) {
        // eslint-disable-next-line no-console
        console.warn("[plugins] runtime already installed - skipping duplicate install");
        return;
    }
    const runtime = {
        shared: {
            react: React,
            reactJss: ReactJss,
            reactRedux: ReactRedux,
            reduxToolkit: ReduxToolkit,
        },
        config: {
            appUrl: APP_URL,
            apiUrl: APP_API_URL,
            imageUrl: APP_IMAGE_ROOT,
            version: APP_VERSION,
        },
        host: hostSelectors,
        register: registry_1.registerClientPlugin,
        get isReady() {
            return readyQueue.isReady;
        },
        onReady: readyQueue.onReady,
    };
    globalThis[api_1.CLIENT_PLUGIN_RUNTIME_KEY] = runtime;
};
exports.installPluginRuntime = installPluginRuntime;
// `index.js` lets webpack's `publicPath: "auto"` derive the chunk base URL at load
// time; the `?v=` content hash busts browser/CDN caches when the bundle changes.
const bundleUrlFor = ({ id, version }) => `/plugins/${id}/index.js?v=${version}`;
const BUNDLE_LOAD_TIMEOUT_MS = 15000;
const loadScript = (url, timeoutMs) => new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url;
    script.async = false;
    const timer = setTimeout(() => {
        script.remove();
        reject(new Error(`Bundle ${url} timed out after ${timeoutMs}ms`));
    }, timeoutMs);
    script.onload = () => {
        clearTimeout(timer);
        resolve();
    };
    script.onerror = () => {
        clearTimeout(timer);
        reject(new Error(`Failed to load client plugin bundle: ${url}`));
    };
    document.head.appendChild(script);
});
/* eslint-disable no-console */
const loadClientPlugins = (manifestUrl) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    console.info(`[plugins] loading manifest: ${manifestUrl}`);
    let manifest;
    try {
        const res = yield fetch(manifestUrl, { cache: "no-cache" });
        if (!res.ok) {
            console.warn(`[plugins] manifest ${manifestUrl} -> HTTP ${res.status}; no client plugins loaded`);
            return;
        }
        const body = yield res.text();
        try {
            manifest = JSON.parse(body);
        }
        catch (_b) {
            const reason = body.trimStart().startsWith("<")
                ? "returned HTML, not JSON - the SPA fallback hit. nginx is " +
                    "likely not proxying /plugins/manifest.json to server-game"
                : "is not valid JSON";
            console.warn(`[plugins] manifest ${manifestUrl} ${reason}; no client plugins loaded`);
            return;
        }
    }
    catch (error) {
        console.warn(`[plugins] manifest ${manifestUrl} not reachable; no client plugins loaded`, error);
        return;
    }
    const entries = (_a = manifest.plugins) !== null && _a !== void 0 ? _a : [];
    console.info(`[plugins] manifest lists ${entries.length}: ${entries.map((e) => e.id).join(", ")}`);
    const settled = yield Promise.allSettled(entries.map((entry) => loadScript(bundleUrlFor(entry), BUNDLE_LOAD_TIMEOUT_MS).catch((error) => {
        // Mark failed at the moment of rejection so a timed-out bundle that
        // still executes can't half-activate via a late register().
        (0, registry_1.markPluginFailed)(entry.id);
        throw error;
    })));
    settled.forEach((result, i) => {
        const id = entries[i].id;
        if (result.status === "fulfilled") {
            console.info(`[plugins] loaded bundle for "${id}"`);
        }
        else {
            console.error(`[plugins] skipping "${id}" - bundle failed to load`, result.reason);
        }
    });
});
exports.loadClientPlugins = loadClientPlugins;
